// import React, { useState, useEffect } from 'react';
// import { Select } from '@windmill/react-ui';
// import AdminServices from "services/AdminServices";

// const SelectSingleState = ({ register, name, label, onChange, stateId }) => {
//   const [states, setStates] = useState([]);
//   const [selectedValue, setSelectedValue] = useState(stateId || ""); // default selection

//   useEffect(() => {
//     async function fetchStates() {
//       try {
//         const response = await AdminServices.getAllState();
//         setStates(response.data);
//       } catch (error) {
//         console.error("Error fetching states:", error);
//       }
//     }
//     fetchStates();
//   }, []);

//   // Update selectedValue if stateId prop changes
//   useEffect(() => {
//     if (stateId) {
//       setSelectedValue(stateId);
//     }
//   }, [stateId]);

//   const handleChange = (e) => {
//     setSelectedValue(e.target.value);
//     if (onChange) onChange(e);
//   };

//   return (
//     <Select
//       className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
//       name={name}
//       value={selectedValue}
//       onChange={handleChange}
//       {...(register ? register(`${name}`, { required: `${label} is required!` }) : {})} // optional
//     >
//       <option value="">Select State</option>
//       {Array.isArray(states) && states.length > 0 ? (
//         states.map((state) => (
//           <option key={state.id_state} value={state.id_state}>
//             {state.name}
//           </option>
//         ))
//       ) : (
//         <option>Loading...</option>
//       )}
//     </Select>
//   );
// };

// export default SelectSingleState;



import React, {
  useState,
  useEffect,
} from "react";
import { Select } from "@windmill/react-ui";
import AdminServices from "services/AdminServices";

const SelectSingleState = ({
  register,
  name,
  label,
  onChange,
  stateId,
}) => {
  const [states, setStates] = useState([]);
  const [selectedValue, setSelectedValue] =
    useState(stateId || "");

  useEffect(() => {
    async function fetchStates() {
      try {
        const response =
          await AdminServices.getAllState();

        setStates(response.data);
      } catch (error) {
        console.error(
          "Error fetching states:",
          error
        );
      }
    }

    fetchStates();
  }, []);

  useEffect(() => {
    if (stateId) {
      setSelectedValue(stateId);
    }
  }, [stateId]);

  const handleChange = (e) => {
    setSelectedValue(e.target.value);

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <Select
      className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      value={selectedValue}
      onChange={handleChange}
      {...(register
        ? register(`${name}`, {
            required: `${label} is required!`,
          })
        : {})}
    >
      <option value="">
        Select State
      </option>

      {Array.isArray(states) &&
      states.length > 0 ? (
        states.map((state) => (
          <option
            key={state.id_state}
            value={state.id_state}
          >
            {state.name}
          </option>
        ))
      ) : (
        <option>Loading...</option>
      )}
    </Select>
  );
};

export default SelectSingleState;